import { PricePlan } from '../lib/price-plan';
import { PricePlanSearchRequest } from '../lib/price-plan-search-request';
import { PricePlanSearchResponse } from '../lib/price-plan-search-response';
import * as actions from './price-plans.actions';

export interface State {
  pricePlanList: PricePlanListState;
  pricePlan: PricePlanState;
}

export interface PricePlanListState {
  isLoading: boolean;
  request: PricePlanSearchRequest;
  payload: PricePlanSearchResponse;
}

export interface PricePlanState {
  isLoading: boolean;
  payload: PricePlan;
}

export const initialState: State = {
  pricePlanList: {
    isLoading: false,
    request: null,
    payload: null,
  },
  pricePlan: {
    isLoading: false,
    payload: null,
  },
};

export function reducer(state = initialState, action: actions.PricePlansActions): State {
  switch (action.type) {
    case actions.PricePlansActionTypes.ResetPricePlanListState:
      return {
        ...state,
        pricePlanList: { ...initialState.pricePlanList },
      };
    case actions.PricePlansActionTypes.ResetPricePlanListPayload:
      return {
        ...state,
        pricePlanList: {
          ...state.pricePlanList,
          payload: null,
        },
      };
    case actions.PricePlansActionTypes.ResetPricePlanState:
      return {
        ...state,
        pricePlan: { ...initialState.pricePlan },
      };
    case actions.PricePlansActionTypes.SetPricePlanListState:
      return {
        ...state,
        pricePlanList: action.payload,
      };
    case actions.PricePlansActionTypes.SetPricePlanState:
      return {
        ...state,
        pricePlan: action.payload,
      };
    default:
      return state;
  }
}
